<template>
<div class="cookies">
    <!-- 中文版 -->
    <el-dialog
    :title="$t('title')"
    :show-close="false"
  :visible.sync="dialogVisible"
  size="tiny" top="36%"
  :before-close="doubleCheck"
 >
  <span>{{$t('info')}}<a :href="`https://karyshop.com/cookies${url}.html`" target="_blank"> {{$t('click')}}</a>{{$t('msg')}}</span>
  <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="doubleCheck(1)" class="butagree">{{$t('agree')}}</el-button>
  </span>
</el-dialog>

</div>
    

</template>

<script>

import {Dialog, Button, Message } from 'element-ui'
import Vue from 'vue'
import { getLangPath } from '../lib/i18n/getLang.js'
Vue.use(Button);
Vue.use(Dialog);
export default {
    data(){
        return{
            dialogVisible:false
        }
    },
    methods: {
       doubleCheck(done){
           if (done !== 1) {
            Message.warning(this.$t('error'))
            return
           }
           this.dialogVisible = false
           localStorage.setItem('cookiesChange', '1')
        setTimeout(() => {
           this.success()
        })
       }
    },
    component:{
        Dialog
    },
    computed: {
        url() {
            let lang = getLangPath();
            if (lang)
                return '';
            return 'en';
        }
    }
}


</script>

<style lang="scss" scoped>
.butagree{
    background: #FF7802;
    border: 1px solid #FF7802;
}
.cookies :global(.el-dialog--tiny){
    width: 370px !important;
}
p{
    color: #333;
    font-size: 16px;
}
 a{
     text-decoration: none;
     color: #FF7802;
      
 }
</style>



// WEBPACK FOOTER //
// resources/js/components/cookies.vue